import React from "react";
import solution from "../assets//articale/4.jpg";

const NaturalSolution = () => {
  return (
    <div>
      <div className="relative w-full mb-6">
        <img
          src={solution}
          alt="Lung diagram with surrounding bacterial images"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
        <p className="font-bold">{"So what's the solution?"}</p>
        <p>
          {"1. Help the body dissolve and expel stagnant mucus from the respiratory tract."}{" "}
        </p>
        <p>{"2.  Support the lungs in staying clear and protected from mucus buildup."}</p>
        <p className="font-bold">{"But How Do You Do That?"}</p>
        <p>
        {"Big pharmaceutical companies will tell you about the next miracle pill or the need for another inhaler for life."}
        </p>

        <p>
          {"But let’s face it—corporations care more about profits than real results without side effects. "}{" "}
          <span className="font-bold">
          {"Luckily, there’s a better, more natural solution."}{" "}
          </span>{" "}
        </p>
      </div>
    </div>
  );
};

export default NaturalSolution;
